import React from 'react'

const Exemple = () => {
	return (
		<div>
			<h1>Météo</h1>
		</div>
	)
}

export default Exemple
